<template>
    <div>
        <modal name="modal-plan-intervention" height="auto" width="70%" :scrollable="true">
            <div class="p-6 min-h-[50vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">Planifier l'intervention</h2>
                    <button @click="$modal.hide('modal-plan-intervention');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <div v-if="selectedPlanIntervention">
                    <!-- <button class="bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700" @click="planInterventionManually">Planifier l'intervention manuellement</button> -->

                    <div class="mt-4">
                        <!-- <intervention-plan-proposition :intervention-id="selectedPlanIntervention.id" @slot-validated="onSlotValidated" /> -->
                        <!-- <intervention-plan-manual :intervention="selectedPlanIntervention" @planned="manualPlan" /> -->
                        <planning-planner :intervention-to-plan="selectedPlanIntervention.id" @event-scheduled="endPlanned" />
                    </div>
                </div>
            </div>
        </modal>

        <!-- 🔎 FILTRES AVANCÉS -->
        <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-4">
            <!-- Recherche globale -->
            <input v-model="filters.search" @input="onFilterChangeDebounced" type="text" placeholder="Recherche globale" class="border px-3 py-2 rounded w-full focus:outline-none" />

            <!-- Statut -->
            <select v-model="filters.status" @change="onFilterChange" class="border px-3 py-2 rounded w-full focus:outline-none">
                <option value="">Tous les statuts</option>
                <option value="a_planifier">Attente de planification</option>
                <option value="planifie">Planifié</option>
                <option value="en_cours">En cours</option>
                <option value="termine">Terminée</option>
                <option value="deplanifie">Déplanifié</option>
            </select>

            <!-- Technicien -->
            <select v-model="filters.technicien_id" @change="onFilterChange" class="border px-3 py-2 rounded w-full focus:outline-none">
                <option value="">Tous les techniciens</option>
                <option v-for="tech in techniciens" :key="tech.id" :value="tech.id">
                    {{ tech.label }}
                </option>
            </select>

            <!-- Ville -->
            <input v-model="filters.ville" @input="onFilterChangeDebounced" type="text" placeholder="Ville" class="border px-3 py-2 rounded w-full focus:outline-none" />

            <!-- Date de début -->
            <input v-model="filters.date_debut" @change="onFilterChange" type="date" class="border px-3 py-2 rounded w-full focus:outline-none" />
        </div>

        <!-- 🧾 TABLEAU -->
        <div class="bg-white rounded shadow overflow-x-auto" v-if="!loading">
            <table class="min-w-full text-sm text-left">
                <thead class="bg-gray-100 text-gray-700">
                    <tr>
                        <th class="px-4 py-2 cursor-pointer w-[150px]" @click="changeSort('reference')">
                            Référence
                            <i v-if="sort_by === 'reference'" class="fas ml-1" :class="sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
                        </th>

                        <th class="px-4 py-2 cursor-pointer w-[200px]" @click="changeSort('client')">
                            Client
                            <i v-if="sort_by === 'client'" class="fas ml-1" :class="sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
                        </th>

                        <th class="px-4 py-2 cursor-pointer" @click="changeSort('type')">
                            Type
                            <i v-if="sort_by === 'type'" class="fas ml-1" :class="sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
                        </th>

                        <th class="px-4 py-2 cursor-pointer" @click="changeSort('adresse')">
                            Adresse
                            <i v-if="sort_by === 'adresse'" class="fas ml-1" :class="sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
                        </th>

                        <th class="px-4 py-2 cursor-pointer" @click="changeSort('date_intervention')">
                            Date
                            <i v-if="sort_by === 'date_intervention'" class="fas ml-1" :class="sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
                        </th>

                        <th class="px-4 py-2">Statut</th>
                        <th class="px-4 py-2 w-48 text-right">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="it in interventions" :key="it.id" class="border-b hover:bg-blue-50 cursor-pointer duration-200" @click="$emit('view', it.id)">
                        <td class="px-4 py-2">{{ it.reference || '-' }}</td>
                        <td class="px-4 py-2">{{ it.client || '-' }}</td>
                        <td class="px-4 py-2">{{ it.type || '-' }}</td>
                        <td class="px-4 py-2">{{ it.adresse || '-' }}</td>
                        <td class="px-4 py-2">{{ it.date | momentDate }}</td>
                        <td class="px-4 py-2">
                            <span class="px-2 py-1 text-xs" :class="statusClass(it.status)">
                                {{ it.status }}
                            </span>
                        </td>
                        <td class="px-4 py-2 flex gap-2 justify-end">
                            <button v-if="it.intervention_statut === 'a_planifier' || it.intervention_statut === 'deplanifie'" @click.stop="planIntervention(it)" class="px-2 py-1 bg-blue-100 hover:bg-blue-200 duration-200 text-blue-700 rounded">
                                <i class="fas fa-calendar-day mr-0.5"></i> Planifier
                            </button>

                            <button @click.stop="supprimer(it.id)" class="px-2 py-1 text-red-500 rounded">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="interventions.length === 0" class="text-center py-6 text-gray-500">
                Aucune intervention trouvée.
            </div>
        </div>

        <!-- LOADING -->
        <div v-if="loading" class="p-10 text-center">
            <i class="fas fa-spinner fa-spin text-3xl text-gray-500"></i>
        </div>

        <!-- 📄 PAGINATION -->
        <div v-if="!loading && lastPage > 1" class="flex flex-wrap justify-between items-center mt-4 gap-3">
            <div class="text-sm text-gray-600">
                Total : {{ total }} interventions
            </div>

            <div class="flex items-center gap-1">
                <button @click="changePage(page - 1)" :disabled="page === 1" class="px-3 py-1 border rounded bg-white hover:bg-gray-100 disabled:opacity-50">
                    <i class="fas fa-chevron-left"></i>
                </button>

                <button v-for="p in pagesToShow" :key="p" @click="changePage(p)" :class="p === page ? 'bg-blue-600 text-white' : 'bg-white'" class="px-3 py-1 border rounded hover:bg-gray-100">
                    {{ p }}
                </button>

                <button @click="changePage(page + 1)" :disabled="page === lastPage" class="px-3 py-1 border rounded bg-white hover:bg-gray-100 disabled:opacity-50">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import PlanningDay from './InterventionPlanningDay.vue';
import InterventionPlanProposition from './InterventionPlanProposition.vue';
import InterventionPlanManual from './InterventionPlanManual.vue';
import PlanningPlanner from "../../Planning/Components/PlanningPlanner.vue";

export default {
    name: "InterventionTable",

    components: {
        PlanningDay,
        InterventionPlanProposition,
        InterventionPlanManual,
        PlanningPlanner
    },

    data() {
        return {
            interventions: [],
            techniciens: [],
            loading: false,

            // Filtres
            filters: {
                search: "",
                status: "a_planifier",
                technicien_id: "",
                ville: "",
                date_debut: "",
            },

            // Tri
            sort_by: "date_intervention",
            sort_dir: "asc",

            // Pagination (back)
            page: 1,
            perPage: 20,
            lastPage: 1,
            total: 0,

            onFilterChangeDebounced: null,

            selectedPlanIntervention: null,
            bestSlots: [],
            selectedSlotPlan: null,
            loadingGetBestSlots: false,
        };
    },

    filters: {
        momentDate(date) {
            if (!date) {
                return '-';
            }
            return moment(date).format("DD/MM/YYYY");
        }
    },

    computed: {
        pagesToShow() {
            const pages = [];
            const max = this.lastPage;

            let start = Math.max(1, this.page - 2);
            let end = Math.min(max, this.page + 2);

            if (start > 1) {
                pages.push(1);
                if (start > 2) pages.push("...");
            }

            for (let p = start; p <= end; p++) {
                pages.push(p);
            }

            if (end < max) {
                if (end < max - 1) pages.push("...");
                pages.push(max);
            }

            // On ne veut pas de "..." cliquable
            return pages.filter(p => p !== "...");
        }
    },

    methods: {
        debounce(fn, delay) {
            let timer = null;
            return (...args) => {
                if (timer) clearTimeout(timer);
                timer = setTimeout(() => fn.apply(this, args), delay);
            };
        },

        statusClass(status) {
            switch (status) {
                case "Prévue":
                    return "text-blue-700";
                case "En cours":
                    return "text-yellow-700";
                case "Terminée":
                    return "text-blue-700";
                default:
                    return "text-gray-700";
            }
        },

        async fetchInterventions() {
            this.loading = true;

            const response = await this.$request.get("/interventions", {
                params: {
                    page: this.page,
                    per_page: this.perPage,
                    search: this.filters.search,
                    status: this.filters.status,
                    technicien_id: this.filters.technicien_id,
                    ville: this.filters.ville,
                    date_debut: this.filters.date_debut,
                    sort_by: this.sort_by,
                    sort_dir: this.sort_dir,
                }
            });

            this.loading = false;

            this.interventions = response.data.map(i => ({
                id: i.id,
                reference: i.reference,
                client: (i.client?.nom || '-') + " " + (i.client?.prenom || '-'),
                type: (i.intervention_type?.nom || '-'),
                adresse: (i.adresse?.code_postal || '-') + " " + (i.adresse?.ville || '-'),
                client_adresse: i.adresse,
                date: i.date_intervention,
                status: i.statut.libelle,
                intervention_statut: i.statut.code,
                duree_estimee: i.duree_estimee
            }));

            this.page = response.current_page;
            this.lastPage = response.last_page;
            this.perPage = response.per_page;
            this.total = response.total;
        },

        async fetchTechniciens() {
            const response = await this.$request.get("/techniciens");

            this.techniciens = response.map(t => ({
                id: t.id,
                label: (t?.prenom || '-') + " " + (t?.nom || '-')
            }));
        },

        changePage(p) {
            if (p < 1 || p > this.lastPage || p === this.page) return;
            this.page = p;
            this.fetchInterventions();
        },

        changeSort(column) {
            if (this.sort_by === column) {
                this.sort_dir = this.sort_dir === "asc" ? "desc" : "asc";
            } else {
                this.sort_by = column;
                this.sort_dir = "asc";
            }
            this.fetchInterventions();
        },

        onFilterChange() {
            this.page = 1;
            this.fetchInterventions();
        },

        async supprimer(id) {
            if (!confirm("Supprimer cette intervention ?")) return;

            await this.$request.post("/interventions/" + id + "/delete");
            this.$toast.success("Intervention supprimée");
            this.fetchInterventions();
        },

        // async getBestSlots() {
        //     this.loadingGetBestSlots = true;
        //     const response = await this.$request.post("/planning/best-slots", {
        //         intervention_id: this.selectedPlanIntervention.id,
        //         preference: 'journee',
        //         start_at: moment().format('YYYY-MM-DD'),
        //     });
        //     this.loadingGetBestSlots = false

        //     this.bestSlots = response.map((slot, index) => ({
        //         ...slot,
        //         id: index
        //     }));
        //     if (this.bestSlots.length > 0) {
        //         this.selectedSlotPlan = this.bestSlots[0]
        //     }
        // },

        async planIntervention(intervention) {
            this.selectedPlanIntervention = intervention

            // this.getBestSlots()
            this.$modal.show("modal-plan-intervention")
        },

        planInterventionManually() {
            this.$emit('plan', this.selectedPlanIntervention)
            this.$eventHub.$emit("PLANIFIER_INTERVENTION", this.selectedPlanIntervention);
        },

        formatDate(date) {
            const d = new Date(date);
            return d.toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },

        computeEndHour(slot) {
            // On va chercher l’item "is_candidate = true"
            const planned = slot.planning.items.find(p => p.is_candidate);

            if (!planned) return '?';

            const end = new Date(planned.end);
            return end.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
            });
        },

        selectSlot(slot) {
            console.log("Slot sélectionné :", slot);
            // ici tu feras l'appel API pour vraiment planifier
        },
        
        onSlotValidated() {
            this.$modal.hide('modal-plan-intervention');
            this.fetchInterventions();
        },

        manualPlan() {
            this.$modal.hide('modal-plan-intervention');
            this.fetchInterventions();
        },

        endPlanned() {
            this.$modal.hide('modal-plan-intervention');
            this.fetchInterventions();
        }
    },

    async mounted() {
        this.onFilterChangeDebounced = this.debounce(this.onFilterChange, 300);
        await this.fetchTechniciens();
        await this.fetchInterventions();

        this.$eventHub.$on('refresh-intervention-table', () => {
            this.fetchInterventions();
            this.$modal.hide('modal-plan-intervention');
        });
    }
};
</script>
